import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { ChecklistSectionDeleteModel } from 'shared/domain/checklistSection/types/model';
import { DeleteChecklistSectionUseCase } from 'shared/domain/checklistSection/types/useCases';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ChecklistSectionHttpDeleteRequestModel } from '../httpQueue/checklistSection/types';

export class ChecklistSectionDeleter implements DeleteChecklistSectionUseCase {
  constructor(
    private addRequest: (
      request: ChecklistSectionHttpDeleteRequestModel
    ) => Promise<number>
  ) {}

  async execute(
    deleteModel: ChecklistSectionDeleteModel,
    uniqueId: string
  ): Promise<void> {
    debugLog('DeleteChecklistSectionUseCase', deleteModel);

    const url = `/project/${deleteModel.projectId}/inspectionTemplate/${deleteModel.inspectionTemplateId}/section/${deleteModel._id}`;

    const request: ChecklistSectionHttpDeleteRequestModel = {
      createdAt: Date.now(),
      method: 'DELETE',
      data: {
        sectionId: deleteModel._id,
        projectId: deleteModel.projectId,
        inspectionTemplateId: deleteModel.inspectionTemplateId,
        uniqueId: uniqueId,
      },
      url,
      entityType: HttpRequestModelType.checklistSection,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const checklistSectionDeleter = new ChecklistSectionDeleter(addRequest);
